<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>协议管理</h1>
        <p>渠道上传 PDF 扫描件后，在这里通过或驳回。通过后记为已签署。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">协议</div><div class="v">{{ list.length }}</div></div>
      <div class="ch-metric"><div class="k">待审批</div><div class="v">{{ pending }}</div></div>
      <div class="ch-metric"><div class="k">已签署</div><div class="v">{{ signed }}</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>渠道</th><th>协议</th><th>扫描件</th><th>有效期</th><th>状态</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>{{ row.name }}</td>
            <td><a v-if="row.fileUrl" :href="row.fileUrl" target="_blank" rel="noopener">查看 PDF</a><span v-else>未上传</span></td>
            <td>{{ row.validUntil || '—' }}</td>
            <td><span class="ch-tag" :class="fileTag(row.status)">{{ fileStatus(row.status) }}</span></td>
            <td>
              <button v-if="row.status === 'PENDING_REVIEW'" class="ch-link" type="button" @click="review(row, 'approve')">通过</button>
              <button v-if="row.status === 'PENDING_REVIEW'" class="ch-link" type="button" @click="review(row, 'reject')">驳回</button>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="6" class="ch-empty">还没有协议</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners, getChannelAgreements, saveChannelAgreement } from '@/api/admin'
import { partnerName } from './lookup'

export default {
  name: 'HqAgreements',
  data() { return { partners: [], list: [] } },
  computed: {
    signed() { return this.list.filter(item => item.status === 'SIGNED').length },
    pending() { return this.list.filter(item => item.status === 'PENDING_REVIEW').length }
  },
  created() { this.load() },
  methods: {
    nameOf(id) { return partnerName(this.partners, id) },
    fileStatus(status) {
      if (status === 'SIGNED') return '已通过'
      if (status === 'PENDING_REVIEW') return '待审批'
      if (status === 'REJECTED') return '已驳回'
      return '待上传'
    },
    fileTag(status) {
      if (status === 'SIGNED') return 'ok'
      if (status === 'REJECTED') return 'bad'
      return 'warn'
    },
    async review(row, action) {
      const verb = action === 'approve' ? '通过' : '驳回'
      try {
        await this.$confirm('确定' + verb + '「' + row.name + '」？', verb, { type: 'warning' })
      } catch (e) {
        return
      }
      await saveChannelAgreement({ id: row.id, action })
      this.$message.success(action === 'approve' ? '已通过' : '已驳回')
      this.load()
    },
    async load() {
      const partners = await getChannelPartners()
      const agreements = await getChannelAgreements()
      this.partners = partners.list || []
      this.list = agreements.list || []
    }
  }
}
</script>
